export default __webpack_public_path__ + "41d69ae39d6fd746f09a12dadc89a6cd.png";